import { CHANGE_WINTER_TIME_RANGE } from "../actions/winterMaintenceTimeRangeActions";

import { states } from "./queriesStates";
import getDates from "./../shared/services/date.service";

const initialState = {
  winterTimeRangeDataState: states.NOT_REQUESTED,
  winterTimeRange: {
    rangeStartDate: getDates.getNullTimeDate(new Date()),
    rangeEndDate: getDates.getNullTimeDate(new Date()),
    rangeStartTime: getDates.getNullTimeDate(new Date()),
    rangeEndTime: getDates.getEndDayTimeDate(new Date()),
  },
};

const winterMaintenceTimeRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_WINTER_TIME_RANGE: {
      const { name, value } = action.payload;
      const winterTimeRange = Object.assign({}, state.winterTimeRange);

      typeof name === "object"
        ? name.map((item, index) => {
            winterTimeRange[item] = value[index];
            return null;
          })
        : (winterTimeRange[name] = value);

      return Object.assign({}, state, {
        dataState: states.READY,
        winterTimeRange: winterTimeRange,
      });
    }
    default:
      return state;
  }
};

export default winterMaintenceTimeRangeReducer;
